export const updatesTranslations = {
  ar: {
    title: 'التحديثات',
    status: 'الحالة',
    versions: 'الإصدارات',
    backups: 'النسخ الاحتياطية',
    currentVersion: 'الإصدار الحالي',
    latestVersion: 'أحدث إصدار',
    updateAvailable: 'تحديث متاح',
    noUpdateAvailable: 'لا يوجد تحديث متاح',
    download: 'تنزيل',
    install: 'تثبيت',
    backup: 'نسخ احتياطي',
    restore: 'استعادة',
    delete: 'حذف',
    createBackup: 'إنشاء نسخة احتياطية',
    creating: 'جاري الإنشاء...',
    downloadSuccess: 'تم تنزيل التحديث بنجاح',
    downloadError: 'فشل تنزيل التحديث',
    backupSuccess: 'تم إنشاء النسخة الاحتياطية بنجاح',
    backupError: 'فشل إنشاء النسخة الاحتياطية',
    installSuccess: 'تم تثبيت الإصدار {version} بنجاح',
    installError: 'فشل التثبيت',
    restoreSuccess: 'تم استعادة النسخة الاحتياطية بنجاح',
    restoreError: 'فشل الاستعادة',
    deleteBackupSuccess: 'تم حذف النسخة الاحتياطية',
    deleteBackupError: 'فشل حذف النسخة الاحتياطية',
    updateSuccess: 'تم التحديث بنجاح!',
    updateError: 'فشل التحديث',
    startingUpdate: 'جاري بدء التحديث...',
    versionNumber: 'رقم الإصدار',
    versionName: 'اسم الإصدار',
    releaseDate: 'تاريخ الإصدار',
    updateType: 'نوع التحديث',
    requiresDatabaseUpdate: 'يتطلب تحديث قاعدة البيانات',
    requiresAPIUpdate: 'يتطلب تحديث API',
    description: 'الوصف',
    createVersion: 'إنشاء نسخة',
    editVersion: 'تعديل النسخة',
    deleteVersion: 'حذف النسخة',
    versionCreateSuccess: 'تم إنشاء النسخة بنجاح',
    versionCreateError: 'فشل إنشاء النسخة',
    versionUpdateSuccess: 'تم تحديث النسخة بنجاح',
    versionUpdateError: 'فشل تحديث النسخة',
    versionDeleteSuccess: 'تم حذف النسخة بنجاح',
    versionDeleteError: 'فشل حذف النسخة',
    confirmDeleteVersion: 'هل أنت متأكد من حذف النسخة "{version}"؟',
    confirmRestore: 'هل أنت متأكد من استعادة هذه النسخة الاحتياطية؟ سيتم استبدال البيانات الحالية.',
    confirmDeleteBackup: 'هل أنت متأكد من حذف هذه النسخة الاحتياطية؟',
    newVersion: 'النسخة الجديدة:',
    updateRequirements: 'متطلبات التحديث:',
    dbUpdateRequired: 'تحديث قاعدة البيانات مطلوب',
    apiUpdateRequired: 'تحديث API مطلوب',
    dbScripts: 'سكريبتات قاعدة البيانات:',
    apiScripts: 'سكريبتات API:',
    updateNow: 'تحديث الآن',
    updating: 'جارٍ التحديث...',
    downloadInstructions: 'تحميل تعليمات التحديث',
    showDetails: 'عرض التفاصيل',
    hideDetails: 'إخفاء التفاصيل',
    updateInstructionsTitle: 'تعليمات تحديث النظام إلى النسخة',
    releaseDateLabel: 'تاريخ الإصدار:',
    updateSteps: 'خطوات التحديث:',
    runDbScripts: '1. قم بتشغيل سكريبتات قاعدة البيانات التالية:',
    updateApiFiles: '2. قم بتحديث ملفات API التالية:',
    updateFrontend: '3. قم بتحديث Frontend',
    updateLocalStorage: '4. قم بتحديث رقم النسخة في localStorage',
    pendingUpdateNote: 'ملاحظة: تفاصيل التحديث محفوظة في localStorage تحت مفتاح "pendingUpdate"',
  },
  en: {
    title: 'Updates',
    status: 'Status',
    versions: 'Versions',
    backups: 'Backups',
    currentVersion: 'Current Version',
    latestVersion: 'Latest Version',
    updateAvailable: 'Update Available',
    noUpdateAvailable: 'No Update Available',
    download: 'Download',
    install: 'Install',
    backup: 'Backup',
    restore: 'Restore',
    delete: 'Delete',
    createBackup: 'Create Backup',
    creating: 'Creating...',
    downloadSuccess: 'Update downloaded successfully',
    downloadError: 'Failed to download update',
    backupSuccess: 'Backup created successfully',
    backupError: 'Failed to create backup',
    installSuccess: 'Version {version} installed successfully',
    installError: 'Installation failed',
    restoreSuccess: 'Backup restored successfully',
    restoreError: 'Restore failed',
    deleteBackupSuccess: 'Backup deleted',
    deleteBackupError: 'Failed to delete backup',
    updateSuccess: 'Update completed successfully!',
    updateError: 'Update failed',
    startingUpdate: 'Starting update...',
    versionNumber: 'Version Number',
    versionName: 'Version Name',
    releaseDate: 'Release Date',
    updateType: 'Update Type',
    requiresDatabaseUpdate: 'Requires Database Update',
    requiresAPIUpdate: 'Requires API Update',
    description: 'Description',
    createVersion: 'Create Version',
    editVersion: 'Edit Version',
    deleteVersion: 'Delete Version',
    versionCreateSuccess: 'Version created successfully',
    versionCreateError: 'Failed to create version',
    versionUpdateSuccess: 'Version updated successfully',
    versionUpdateError: 'Failed to update version',
    versionDeleteSuccess: 'Version deleted successfully',
    versionDeleteError: 'Failed to delete version',
    confirmDeleteVersion: 'Are you sure you want to delete version "{version}"?',
    confirmRestore: 'Are you sure you want to restore this backup? Current data will be replaced.',
    confirmDeleteBackup: 'Are you sure you want to delete this backup?',
    newVersion: 'New Version:',
    updateRequirements: 'Update Requirements:',
    dbUpdateRequired: 'Database update required',
    apiUpdateRequired: 'API update required',
    dbScripts: 'Database Scripts:',
    apiScripts: 'API Scripts:',
    updateNow: 'Update Now',
    updating: 'Updating...',
    downloadInstructions: 'Download Update Instructions',
    showDetails: 'Show Details',
    hideDetails: 'Hide Details',
    updateInstructionsTitle: 'Update Instructions for Version',
    releaseDateLabel: 'Release Date:',
    updateSteps: 'Update Steps:',
    runDbScripts: '1. Run the following database scripts:',
    updateApiFiles: '2. Update the following API files:',
    updateFrontend: '3. Update Frontend',
    updateLocalStorage: '4. Update version number in localStorage',
    pendingUpdateNote: 'Note: Update details are saved in localStorage under key "pendingUpdate"',
  },
  fr: {
    title: 'Mises à jour',
    status: 'Statut',
    versions: 'Versions',
    backups: 'Sauvegardes',
    currentVersion: 'Version actuelle',
    latestVersion: 'Dernière version',
    updateAvailable: 'Mise à jour disponible',
    noUpdateAvailable: 'Aucune mise à jour disponible',
    download: 'Télécharger',
    install: 'Installer',
    backup: 'Sauvegarde',
    restore: 'Restaurer',
    delete: 'Supprimer',
    createBackup: 'Créer une sauvegarde',
    creating: 'Création...',
    downloadSuccess: 'Mise à jour téléchargée avec succès',
    downloadError: 'Échec du téléchargement de la mise à jour',
    backupSuccess: 'Sauvegarde créée avec succès',
    backupError: 'Échec de la création de la sauvegarde',
    installSuccess: 'Version {version} installée avec succès',
    installError: 'Échec de l\'installation',
    restoreSuccess: 'Sauvegarde restaurée avec succès',
    restoreError: 'Échec de la restauration',
    deleteBackupSuccess: 'Sauvegarde supprimée',
    deleteBackupError: 'Échec de la suppression de la sauvegarde',
    updateSuccess: 'Mise à jour terminée avec succès!',
    updateError: 'Échec de la mise à jour',
    startingUpdate: 'Démarrage de la mise à jour...',
    versionNumber: 'Numéro de version',
    versionName: 'Nom de la version',
    releaseDate: 'Date de publication',
    updateType: 'Type de mise à jour',
    requiresDatabaseUpdate: 'Nécessite une mise à jour de la base de données',
    requiresAPIUpdate: 'Nécessite une mise à jour de l\'API',
    description: 'Description',
    createVersion: 'Créer une version',
    editVersion: 'Modifier la version',
    deleteVersion: 'Supprimer la version',
    versionCreateSuccess: 'Version créée avec succès',
    versionCreateError: 'Échec de la création de la version',
    versionUpdateSuccess: 'Version mise à jour avec succès',
    versionUpdateError: 'Échec de la mise à jour de la version',
    versionDeleteSuccess: 'Version supprimée avec succès',
    versionDeleteError: 'Échec de la suppression de la version',
    confirmDeleteVersion: 'Êtes-vous sûr de vouloir supprimer la version "{version}"?',
    confirmRestore: 'Êtes-vous sûr de vouloir restaurer cette sauvegarde? Les données actuelles seront remplacées.',
    confirmDeleteBackup: 'Êtes-vous sûr de vouloir supprimer cette sauvegarde?',
  },
}

